<ng-container>
    <h3 mat-dialog-title [innerHTML]="'DEVICES.MASTERPASSWORD_TITLE' | transloco : { serial: data.serialNumber }"></h3>
    <mat-dialog-content>
        <mat-form-field appearance="outline" *im2mLet="{ password: password$ | async, loading: loading$ | async } as data">
            <mat-label>{{ 'DEVICES.MASTERPASSWORD' | transloco }}</mat-label>
            <input matInput [readonly]="true" [value]="data?.loading ? null : data?.password" [type]="hide ? 'password' : 'text'" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint *ngIf="!data?.loading && !data?.password">{{ 'DEVICES.NO_MASTERPASSWORD' | transloco }}</mat-hint>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="onCancel()">{{ 'CLOSE' | transloco }}</button>
    </mat-dialog-actions>
</ng-container>
